import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../../../context/AuthContext';
import authService from '../../../../services/auth.service';
import { FiMail, FiLock, FiAlertCircle } from 'react-icons/fi';
import './Login.css';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const { login } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const result = await login(email, password);

            if (result.success) {
                // Verificar si tiene Gmail vinculado
                const user = await authService.getCurrentUser();

                const tourKey = `idevplus_tour_visto_${user.id}`;
                const hasSeenTour = localStorage.getItem(tourKey);

                if (!hasSeenTour) {
                    // Es su primera vez en el dispositivo, enviamos al Home para que inicie el Tour Guiado
                    navigate('/');
                } else if (user?.empresa && !user.empresa.usa_gmail_propio) {
                    navigate('/app/configuracion', {
                        state: {
                            showGmailWarning: true,
                            message: "Para enviar cotizaciones, gestionar empleados y enviar correos desde tu empresa, es OBLIGATORIO vincular una cuenta de Google."
                        }
                    });
                } else {
                    navigate('/');
                }
            } else {
                setError('Error de inicio de sesión: Revisa que tu correo y contraseña sean correctos.');
            }
        } catch (err) {
            setError('Error de conexión. Verifica tu internet e intenta nuevamente.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-page-bg">
            <div className="visual-placeholder" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', overflow: 'hidden', zIndex: 0 }}>
                <div className="floating-circle circle-1"></div>
                <div className="floating-circle circle-2" style={{ bottom: '10%', left: '10%' }}></div>
            </div>

            <div className="login-container" style={{ zIndex: 1, position: 'relative' }}>
                <div className="login-card">
                    <div className="login-header">
                        <Link to="/" style={{ color: 'var(--text-secondary)', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '5px', fontSize: '0.9rem', fontWeight: 500, marginBottom: '15px' }}>
                            ← Volver al inicio
                        </Link>
                        <h1>IdevPlus</h1>
                        <p>Accede a tu cuenta</p>
                    </div>

                    {error && (
                        <div className="alert-custom alert-danger">
                            <FiAlertCircle size={20} />
                            <span>{error}</span>
                        </div>
                    )}

                    <form onSubmit={handleSubmit} className="login-form">
                        <div className="form-group-custom">
                            <label className="form-label-custom">
                                <FiMail size={16} />
                                Correo electrónico
                            </label>
                            <input
                                type="email"
                                className="form-control-custom"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="tu@email.com"
                                required
                                autoFocus
                            />
                        </div>

                        <div className="form-group-custom">
                            <label className="form-label-custom">
                                <FiLock size={16} />
                                Contraseña
                            </label>
                            <input
                                type="password"
                                className="form-control-custom"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="••••••••"
                                required
                            />
                        </div>

                        <button
                            type="submit"
                            className="btn-custom btn-primary btn-lg"
                            disabled={loading}
                            style={{ width: '100%', justifyContent: 'center' }}
                        >
                            {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
                        </button>
                    </form>

                    <div className="login-footer">
                        <Link to="/request-password-reset" style={{ marginBottom: '10px', display: 'block', color: 'var(--text-secondary)' }}>¿Olvidaste tu contraseña?</Link>
                        <p>¿Aún no tienes cuenta? <Link to="/register">Crear cuenta Demo</Link></p>
                    </div>
                </div>

                <div className="login-info">
                    <h2>IdevPlus</h2>
                    <p style={{ fontSize: '1.2rem', fontWeight: '500', marginBottom: '30px' }}>
                        🚀 <strong>Prueba Gratis 30 Días</strong> - La suma para tu negocio
                    </p>
                    <ul>
                        <li>Gestión integral de clientes y productos</li>
                        <li>Cotizaciones profesionales en segundos</li>
                        <li>Facturación electrónica simplificada</li>
                        <li>Suscripción mensual accesible</li>
                        <li>Soporte técnico prioritario</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default Login;
